import React from 'react';
import ClientsCarousel from '../Landing/ClientsCarousel';

const Partners = () => {
    return (  
        <>
        <ClientsCarousel/>
        </>
    );
}
 
export default Partners;